export default __webpack_public_path__ + "static/media/army_21.0b340965.jpg";